import { jsx as _jsx } from "react/jsx-runtime";
import { getTemplate, getUiOptions, titleId } from '@rjsf/utils';
/** The `ArrayFieldTitleTemplate` component renders a `TitleFieldTemplate` with an `id` derived from
 * the `idSchema`.
 *
 * @param props - The `ArrayFieldTitleProps` for the component
 */

export default function ArrayFieldTitleTemplate(props) {
  var idSchema = props.idSchema,
      title = props.title,
      schema = props.schema,
      uiSchema = props.uiSchema,
      required = props.required,
      registry = props.registry;
  var options = getUiOptions(uiSchema, registry.globalUiOptions);
  var _options$label = options.label,
      displayLabel = _options$label === void 0 ? true : _options$label;

  if (!title || !displayLabel) {
    return null;
  }

  var TitleFieldTemplate = getTemplate('TitleFieldTemplate', registry, options);
  return _jsx(TitleFieldTemplate, {
    id: titleId(idSchema),
    title: title,
    required: required,
    schema: schema,
    uiSchema: uiSchema,
    registry: registry
  });
}